<template>
  <Toast />
  <ConfirmDialog />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >INVENTARIO</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">TRASPASOS</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-center flex-column lg:justify-content-center lg:flex-row"
    >
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>REGISTRAR TRASPASO DE PRODUCTOS</strong>
      </span>
    </div>
    <div class="col-12 p-fondo">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-3">
          <span><strong>PREPARADO POR:</strong></span>
          <Dropdown
            v-model="userSelected"
            :options="users"
            optionLabel="name"
            optionValue="id"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>RECIBIDO POR:</strong></span>
          <Dropdown
            v-model="userRecibeSelected"
            :options="users"
            optionLabel="name"
            optionValue="id"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>ORIGEN:</strong></span>
          <Dropdown
            v-model="sucursalSelected"
            :options="sucursales"
            optionLabel="nombre"
            optionValue="id"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>DESTINO:</strong></span>
          <Dropdown
            v-model="sucursalDestinoSelected"
            :options="sucursales"
            optionLabel="nombre"
            optionValue="id"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <span><strong>BUSCAR PRODUCTO:</strong></span>
          <AutoComplete
            :dropdown="true"
            field="descripcion"
            v-model="productoSelected"
            :suggestions="productosListadoFiltrado"
            @complete="buscarProducto($event)"
            placeholder="Buscar Producto"
            @item-select="agregarProductoDetalle"
          >
            <template #item="slotProps">
              <div>
                {{ slotProps.item.descripcion }} <strong>**</strong>
                {{ slotProps.item.fabrica_nombre }} <strong>**</strong>
                <span
                  :class="
                    stockClass(
                      slotProps.item.stock.length > 0
                        ? (slotProps.item.stock[0].cantidad_gramos || slotProps.item.stock[0].cantidad || 0)
                        : 0
                    )
                  "
                >
                  <strong>
                    <template v-if="parseFloat(slotProps.item.gramaje_unidad || 0) > 0">
                      {{ Math.floor((slotProps.item.stock[0]?.cantidad_gramos || slotProps.item.stock[0]?.cantidad || 0) / parseFloat(slotProps.item.gramaje_unidad)) }} Porción(es)
                    </template>
                    <template v-else>
                      {{ slotProps.item.stock.length > 0 ? slotProps.item.stock[0].cantidad : 0 }} Unid.
                    </template>
                  </strong>
                </span>
              </div>
            </template>
          </AutoComplete>
          <small class="p-invalid" v-if="errors.productoSelected">{{
            errors.productoSelected[0]
          }}</small>
        </div>

        <div class="field col-12 md:col-4">
          <span><strong>OBSERVACIONES:</strong></span>
          <Textarea
            v-model="observaciones"
            :autoResize="true"
            :rows="1"
            placeholder="Observaciones"
          ></Textarea>
        </div>
        <div class="field col-12 md:col-2">
          <span><strong>ACCIONES:</strong></span>
          <Button
            label="REGISTRAR"
            icon="pi pi-save"
            class="p-button-info p-button-lg"
            v-tooltip.top="'Registrar Movimiento'"
            @click="guardarMovimiento"
            :loading="enviando"
            :disabled="enviando || sucursales.length <= 1"
          />
        </div>
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="traspasos"
        key="id"
        :value="traspasos"
        responsiveLayout="scroll"
        :loading="enviando"
        class="p-datatable-sm"
        responsive="true"
        stripedRows
        showGridlines
        selectionMode="single click"
      >
        <template #loading
          ><div class="flex align-items-center justify-content-center">
            <ProgressSpinner /></div
        ></template>
        <template #empty>
          <div class="flex align-items-center justify-content-center">
            <div class="p-invalid">No existen Productos en el detalle!</div>
          </div>
        </template>
        <Column header="#" class="text-right" style="width: 2em">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>
        <Column
          field="codigo_interno"
          header="CÓD."
          class="text-right"
        ></Column>
        <Column field="fabrica_nombre" header="MARCA"></Column>
        <!-- <Column field="proveedor_nombre" header="PROVEEDOR"></Column> -->
        <Column
          field="producto"
          header="DETALLE/PRODUCTO"
          style="font-weight: bold"
        ></Column>
        <Column field="unidad_medida_nombre" header="U/M">
          <template #body="{ data }">
            <Tag
              v-if="data.es_porcionado || data.es_fraccionado"
              severity="warning"
              value="GRAMOS (g)"
            />
            <span v-else>{{ data.unidad_medida_nombre || 'UNIDAD' }}</span>
          </template>
        </Column>
        <Column class="text-center bold" field="stock_actual" header="STOCK ORIGEN" style="min-width: 170px;">
          <template #body="slotProps">
            <!-- Contenedor principal con flexbox, fondo verde suave, borde y padding -->
            <div 
              v-if="(slotProps.data.stock_gramos ?? slotProps.data.stock_actual) > 0" 
              class="flex flex-column align-items-center justify-content-center bg-green-100 text-green-900 border-round p-2 border-1 border-green-400 w-full text-center"
            >
              <!-- Texto principal (Gramos o Unidades) más grande y en negrita -->
              <span class="text-base md:text-lg font-bold mb-1">
                {{ (slotProps.data.stock_gramos ?? slotProps.data.stock_actual).toLocaleString() }} {{ (slotProps.data.es_porcionado || slotProps.data.es_fraccionado) ? 'g' : 'Unid.' }}
              </span>
              
              <!-- Texto secundario (Porciones) con tamaño legible y contraste ajustado -->
              <span 
                v-if="(slotProps.data.es_porcionado || slotProps.data.es_fraccionado || slotProps.data.gramaje_unidad > 0) && slotProps.data.gramaje_unidad > 0" 
                class="text-xs md:text-sm font-medium text-green-700"
              >
                Equivale a {{ slotProps.data.porciones_disponibles ?? Math.floor((slotProps.data.stock_gramos ?? slotProps.data.stock_actual) / slotProps.data.gramaje_unidad) }} porciones
              </span>
            </div>

            <!-- Estado sin stock -->
            <div 
              v-else 
              class="flex flex-column align-items-center justify-content-center bg-red-100 text-red-900 border-round p-2 border-1 border-red-400 w-full text-center"
            >
              <span class="font-bold text-base">Agotado</span>
            </div>
          </template>
        </Column>
        <Column header="LOTES / VENCIMIENTO" class="text-center">
          <template #body="{ data }">
            <Button
              :label="data.fechas_vencimiento && data.fechas_vencimiento.length > 0 ? `${data.fechas_vencimiento.length} Lote(s)` : 'Seleccionar Lotes'"
              :class="data.fechas_vencimiento && data.fechas_vencimiento.length > 0 ? 'p-button-outlined p-button-success p-button-sm' : 'p-button-outlined p-button-secondary p-button-sm'"
              icon="pi pi-calendar"
              @click="abrirModalLotes(data)"
            />
          </template>
        </Column>
        <Column class="text-center bold bg-green-100" header="CANTIDAD A TRASPASAR" style="min-width: 160px;">
          <template #body="{ data }">
            <!-- PRODUCTOS PORCIONADOS -->
            <div v-if="data.es_porcionado || data.es_fraccionado" class="flex flex-column align-items-center">
              <div class="p-inputgroup" style="max-width: 130px;">
                <InputNumber
                  v-model="data.porciones_a_traspasar"
                  :min="1"
                  :max="data.porciones_disponibles ?? data.stock_disponible_porciones ?? 99999"
                  inputClass="text-center font-bold text-orange-700 p-inputtext-sm"
                  @update:modelValue="(val) => {
                    const num = val !== null && val !== undefined && val !== '' ? parseFloat(val) : 0;
                    data.porciones_a_traspasar = num;
                    data.porciones = num;
                    data.cantidad = num * parseFloat(data.gramaje_unidad || 1);
                  }"
                />
                <span class="p-inputgroup-addon font-bold text-xs">Porc.</span>
              </div>
              <small class="text-xs text-600 font-semibold mt-1">
                (= {{ (data.porciones_a_traspasar * data.gramaje_unidad).toLocaleString() }} g)
              </small>
            </div>

            <!-- PRODUCTOS ESTÁNDAR (Sodas, Abarrotes) -->
            <div v-else class="flex flex-column align-items-center">
              <div class="p-inputgroup" style="max-width: 120px;">
                <InputNumber
                  v-model="data.cantidad"
                  :min="1"
                  :max="data.stock_actual"
                  inputClass="text-center font-bold text-blue-700 p-inputtext-sm"
                />
                <span class="p-inputgroup-addon font-bold text-xs">Unid.</span>
              </div>
            </div>
          </template>
        </Column>
        <!-- <Column field="precio_compra" header="PUCompra" class="text-right">
            {{ data.precio_compra }}
          </Column>
          <Column
            class="text-right strong"
            field="precio_venta"
            header="PUVenta"
          >
            <template #body="slotProps">
              {{ convertirNumeroGermanicFormat(slotProps.data.precio_venta) }}
            </template>
            <template #editor="{ data, field }">
              <InputNumber
                v-model="data[field]"
                input-class="flex-row-reverse"
                locale="de-DE"
                class="p-inputtext-sm"
                :min="1"
                :minFractionDigits="2"
                :maxFractionDigits="2"
              />
            </template>
          </Column> -->
        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              @click="quitarProductoDetalle(slotProps)"
              v-tooltip.top="'Quitar Producto'"
              icon="pi pi-times"
              class="p-button-rounded p-button-danger p-button-text"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
    <!-- Modal de Selección de Lotes reusado con props corregidas -->
  <FechaVence
    :show="displayFechaVence"
    :producto="productoModalData"
    @closeModal="cerrarModalLotes"
  />
</template>
<script>
import Tag from "primevue/tag";
import FechaVence from "@/module/compras/FechaVence.vue";
import SucursalService from "@/service/SucursalService";
import ProductService from "@/service/ProductService";
import MovimientoInventarioService from "@/service/MovimientoInventarioService";
import UserService from "@/service/UserService";
import { useAuth } from "@/stores";

export default {
  components: { FechaVence, Tag },
  data() {
    return {
      traspasos: [],
      displayFechaVence: false,
      productoModalData: { descripcion: "", pivot: { cantidad: 0 }, fechas_vencimiento: [] },
      productoModalId: null,
      fechasVenceSeleccionadas: [],
      productoEditarLotes: null,
      sucursalSelected: 1,
      sucursalDestinoSelected: 2,
      sucursales: [],
      tipoMovimientos: [],
      tipoMovimientoSelected: 1,
      productoSelected: null,
      productosListadoFiltrado: [],
      fecha_movimiento: new Date(),
      enviando: false,
      errors: {},
      stockClass: (data) => {
        if (data <= 0) {
          return "outofstock";
        } else if (data <= 10) {
          return "lowstock";
        } else {
          return "instock";
        }
      },
      claseEstado: (data) => {
        if (data.stock_actual <= 0) {
          return "outofstock";
        } else if (data.stock_actual <= 10) {
          return "lowstock";
        } else {
          return "instock";
        }
      },
      users: [],
      userSelected: null,
      observaciones: "",
      userRecibeSelected: null,
    };
  },
  sucursalService: null,
  productService: null,
  movimientoInventarioService: null,
  userService: null,
  auth: null,
  created() {
    this.sucursalService = new SucursalService();
    this.productService = new ProductService();
    this.movimientoInventarioService = new MovimientoInventarioService();
    this.userService = new UserService();
    this.auth = useAuth();
  },
  mounted() {
    this.cargarSucursales();
    this.cargarUsuarios();
  },
  methods: {
    cargarUsuarios() {
      this.userService.getUsersAll().then((data) => {
        this.users = data;
        //cargo el usuario logueado
        this.users.forEach((user) => {
          if (user.id == this.auth.user.id) {
            this.userSelected = user.id;
          }
        });
      });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numero);
    },
    validarFormulario() {
      if (
        this.sucursalSelected == null ||
        this.sucursalDestinoSelected == null
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar una sucursal",
          life: 3000,
        });
        return false;
      }

      if (this.sucursalDestinoSelected == this.sucursalSelected) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "La sucursal de origen y destino no pueden ser iguales",
          life: 3000,
        });
        return false;
      }
      if (this.userSelected == null) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar un usuario de entrega",
          life: 3000,
        });
        return false;
      }

      if (this.userRecibeSelected == null) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar un usuario de recepción",
          life: 3000,
        });
        return false;
      }

      if (this.traspasos.length == 0) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe agregar al menos un producto al detalle",
          life: 3000,
        });
        return false;
      }
      return true;
    },
    guardarMovimiento() {
      if (this.enviando) return;
      if (this.validarFormulario()) {
        this.enviando = true;
        let datos = {
          sucursal_id: this.sucursalSelected,
          sucursal_destino_id: this.sucursalDestinoSelected,
          productos: this.traspasos,
          user_id: this.userSelected,
          user_recibe_id: this.userRecibeSelected,
          observaciones: this.observaciones,
        };
        this.$confirm.require({
          header: "Confirmación",
          message: "¿ESTÁS SEGURO DE GUARDAR EL MOVIMIENTO?",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Si, Guardar",
          rejectLabel: "No, Cancelar",
          acceptClass: "p-button-primary p-button-lg",
          rejectClass: "p-button-danger p-button-lg",
          acceptIcon: "pi pi-save",
          rejectIcon: "pi pi-times",
          discard: () => {
            this.guardando = false;
          },
          accept: () => {
            this.movimientoInventarioService
              .nuevoMovimiento(datos)
              .then((data) => {
                if (data.status == 400) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: data.message,
                    life: 3000,
                  });
                  this.enviando = false;
                  return;
                } else {
                  this.$toast.add({
                    severity: "success",
                    summary: "Éxito",
                    detail: data.message,
                    life: 3000,
                  });
                  this.enviando = false;
                  this.traspasos = [];
                  this.observaciones = "";
                  this.userRecibeSelected = null;
                  /* this.imprimirMovimiento(mov_almacen.id); */
                }
              });
          },
          reject: () => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "No se guardo el movimiento",
              life: 3000,
            });
            this.enviando = false;
          },
        });
      }
    },
    /*  imprimirMovimiento(id) {
      this.nuevoMovimiento
        .imprimirMov(id)
        .then(() => {})
        .catch((error) => console.log(error));
    }, */
    guardandoCambiosCelda(e) {
      let { data, newValue } = e;
      if (data.es_porcionado || data.es_fraccionado) {
        let porcionesVal = newValue !== null && newValue !== undefined && newValue !== '' ? parseFloat(newValue) : parseFloat(data.porciones_a_traspasar || 0);
        let maxPorc = data.porciones_disponibles ?? data.stock_disponible_porciones ?? 99999;
        if (maxPorc > 0 && porcionesVal > maxPorc) {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Las porciones no pueden superar el stock disponible (${maxPorc} porciones)`,
            life: 3000,
          });
          porcionesVal = maxPorc;
        }
        data.porciones_a_traspasar = porcionesVal;
        data.porciones = porcionesVal;
        data.cantidad = porcionesVal * parseFloat(data.gramaje_unidad || 0);
      } else {
        let cantVal = newValue !== null && newValue !== undefined && newValue !== '' ? parseFloat(newValue) : parseFloat(data.cantidad || 0);
        if (cantVal > data.stock_actual) {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "La cantidad no puede ser mayor al stock actual",
            life: 3000,
          });
          cantVal = parseFloat(data.stock_actual);
        }
        data.cantidad = cantVal;
      }
    },
    agregarProductoDetalle() {
      if (this.productoSelected == null) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar un producto",
          life: 3000,
        });
        return;
      }
      //Verificar si el producto ya esta en el detalle
      let existe = this.traspasos.find((item) => {
        return item.id == this.productoSelected.id;
      });

      if (existe) {
        this.errors.productoSelect = ["El producto ya esta en el detalle"];
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "El producto ya esta en el detalle",
          life: 3000,
        });
        this.enviando = false;
        return false;
      }

      if (this.cantidad <= 0 || this.cantidad === null) {
        this.errors.cantidad = ["La cantidad debe ser mayor a 0"];
        return false;
      }

      // verifico el stock_actual del producto seleccionado
      let stockReg = this.productoSelected.stock && this.productoSelected.stock.length > 0 ? this.productoSelected.stock[0] : null;
      let cantStockAvailable = stockReg ? (parseFloat(stockReg.cantidad_gramos) || parseFloat(stockReg.cantidad) || 0) : 0;

      if (cantStockAvailable <= 0) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "El producto no tiene stock disponible",
          life: 3000,
        });
        return false;
      }

      let producto = this.productoSelected;
      console.log("PRODUCTO SELECCIONADO:", producto);

      let gramaje = parseFloat(producto.gramaje_unidad || 0);
      const esPorcionado = gramaje > 0;

      let detalle = {};

      if (esPorcionado) {
        let stockGramos = stockReg ? parseFloat(stockReg.cantidad_gramos || stockReg.cantidad || 0) : 0;
        let porcionesDisponibles = Math.floor(stockGramos / gramaje);

        detalle = {
          id: producto.id,
          fechas_vencimiento: [],
          codigo_interno: producto.codigo_interno,
          producto: producto.descripcion,
          tipo_catalogo: producto.tipo_catalogo,
          es_producido: producto.es_producido,
          es_porcionado: true,
          es_fraccionado: true,
          gramaje_unidad: gramaje,
          stock_gramos: stockGramos,
          porciones_disponibles: porcionesDisponibles,
          porciones_a_traspasar: 1,
          porciones: 1,
          stock_disponible_porciones: porcionesDisponibles,
          stock_actual: stockGramos,
          cantidad: gramaje, // 1 porción expresada en gramos
          precio_compra: parseFloat(stockReg?.cpp) || 0,
          precio_venta: parseFloat(stockReg?.ultimo_precio) || 0,
          margen:
            parseFloat(stockReg?.ultimo_precio || 0) -
            parseFloat(producto.precio_compra || 0),
          margen_porcentaje:
            ((parseFloat(stockReg?.ultimo_precio || 0)) /
              (parseFloat(producto.precio_compra || 1))) *
            100,
          redondeo: 0,
          fabrica_nombre: producto.fabrica_nombre,
          proveedor_nombre: producto.fabricas?.proveedor?.nombre_completo || '',
          unidad_medida_nombre: 'GRAMOS (g)',
        };
      } else {
        let stockUnidades = stockReg ? parseFloat(stockReg.cantidad || 0) : 0;

        detalle = {
          id: producto.id,
          fechas_vencimiento: [],
          codigo_interno: producto.codigo_interno,
          producto: producto.descripcion,
          tipo_catalogo: producto.tipo_catalogo,
          es_producido: producto.es_producido,
          es_porcionado: false,
          es_fraccionado: false,
          gramaje_unidad: 0,
          porciones: 0,
          stock_disponible_porciones: stockUnidades,
          stock_actual: stockUnidades,
          cantidad: 1, // 1 unidad
          precio_compra: parseFloat(stockReg?.cpp) || 0,
          precio_venta: parseFloat(stockReg?.ultimo_precio) || 0,
          margen:
            parseFloat(stockReg?.ultimo_precio || 0) -
            parseFloat(producto.precio_compra || 0),
          margen_porcentaje:
            ((parseFloat(stockReg?.ultimo_precio || 0)) /
              (parseFloat(producto.precio_compra || 1))) *
            100,
          redondeo: 0,
          fabrica_nombre: producto.fabrica_nombre,
          proveedor_nombre: producto.fabricas?.proveedor?.nombre_completo || '',
          unidad_medida_nombre: producto.unidad_medida_nombre || 'UNIDAD',
        };
      }

      this.traspasos.push(detalle);
      this.productoSelected = null;
    },
    buscarProducto(event) {
      setTimeout(() => {
        this.productService
          .buscarXNombre({
            texto: event.query,
            sucursal_id: this.sucursalSelected,
            contexto: "traspaso",
          })
          .then((response) => {
            this.productosListadoFiltrado = [...response.productos];
          })
          .catch((error) => console.log(error));
      }, 250);
    },
    cargarSucursales() {
      this.sucursalService
        .getSucursalesAll()
        .then((response) => {
          response.forEach((sucursal) => {
            this.sucursales.push(sucursal);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async abrirModalLotes(data) {
      this.productoEditarLotes = data;
      
      // Consultar lotes reales existentes en la sucursal origen
      let lotesExistentes = [];
      try {
        let res = await this.productService.getLotesDisponibles(data.id, this.sucursalSelected);
        if (res && res.lotes) {
          lotesExistentes = res.lotes;
        }
      } catch (e) {
        console.log("Error al consultar lotes disponibles:", e);
      }

      let gramaje = parseFloat(data.gramaje_unidad || 0);
      let esPorcionado = data.es_porcionado || data.es_fraccionado || gramaje > 0;

      // Cantidad / Porciones totales requeridas por el usuario
      let totalPorcionesRequeridas = data.porciones_a_traspasar ?? data.porciones ?? (gramaje > 0 ? Math.floor((data.cantidad || 0) / gramaje) : 0);
      let totalCantidadRequerida = parseFloat(data.cantidad || 0);

      let porcionesRestantes = totalPorcionesRequeridas;
      let gramosRestantes = totalCantidadRequerida;

      // Pre-poblar el array de fechas_vencimiento para FechaVence.vue
      let fechasArray = [];
      if (lotesExistentes.length > 0) {
        // Mapear previas asignaciones registradas en el producto
        const yaAsignadosPreviamente = {};
        if (data.fechas_vencimiento && data.fechas_vencimiento.length > 0) {
          data.fechas_vencimiento.forEach(fv => {
            if (fv.lote) {
              yaAsignadosPreviamente[fv.lote] = fv;
            }
          });
        }

        fechasArray = lotesExistentes.map((l) => {
          let lGramaje = parseFloat(l.gramaje_unidad || gramaje || 0);
          let stockLoteGramos = parseFloat(l.cantidad || 0);
          let porcionesDisponiblesLote = l.porciones_disponibles != null 
            ? parseFloat(l.porciones_disponibles)
            : (lGramaje > 0 ? Math.floor(stockLoteGramos / lGramaje) : 0);

          let cantAsignada = 0;
          let porcionesAsignadas = 0;

          if (yaAsignadosPreviamente[l.lote]) {
            let prev = yaAsignadosPreviamente[l.lote];
            cantAsignada = parseFloat(prev.cantidad || 0);
            porcionesAsignadas = prev.porciones != null ? parseFloat(prev.porciones) : (lGramaje > 0 ? Math.floor(cantAsignada / lGramaje) : 0);
          } else {
            // Sugerencia inteligente: Min(Faltante, DisponibleEnLote)
            if (esPorcionado && lGramaje > 0) {
              porcionesAsignadas = Math.max(0, Math.min(porcionesRestantes, porcionesDisponiblesLote));
              cantAsignada = porcionesAsignadas * lGramaje;
            } else {
              cantAsignada = Math.max(0, Math.min(gramosRestantes, stockLoteGramos));
              porcionesAsignadas = 0;
            }
          }

          // Descontar lo asignado de los sobrantes a requerir
          porcionesRestantes = Math.max(0, porcionesRestantes - porcionesAsignadas);
          gramosRestantes = Math.max(0, gramosRestantes - cantAsignada);

          return {
            id: l.id,
            lote: l.lote,
            fecha_vence: l.fecha_vence ? new Date(l.fecha_vence + "T00:00:00") : new Date(),
            disponible: stockLoteGramos,
            gramaje_unidad: lGramaje,
            es_producido: l.es_producido || 0,
            porciones_disponibles: porcionesDisponiblesLote,
            porciones: porcionesAsignadas,
            cantidad: cantAsignada
          };
        });
      } else if (data.fechas_vencimiento && data.fechas_vencimiento.length > 0) {
        fechasArray = data.fechas_vencimiento.map((fv) => ({
          ...fv,
          fecha_vence: fv.fecha_vence instanceof Date ? fv.fecha_vence : new Date(fv.fecha_vence)
        }));
      }

      this.productoModalData = {
        descripcion: `${data.producto} (Disponibles en Origen)`,
        pivot: { 
          cantidad: data.cantidad,
          porciones: totalPorcionesRequeridas
        },
        gramaje_unidad: gramaje,
        es_porcionado: esPorcionado,
        fechas_vencimiento: fechasArray
      };

      this.displayFechaVence = true;
    },
    cerrarModalLotes() {
      if (this.productoEditarLotes && this.productoModalData.fechas_vencimiento) {
        // Guardar lotes asignados con cantidad mayor a cero
        let asignados = this.productoModalData.fechas_vencimiento.filter(
          (fv) => parseFloat(fv.cantidad || 0) > 0
        );
        
        let lotesProcesados = asignados.map((fv) => ({
          lote: fv.lote,
          fecha_vence: fv.fecha_vence instanceof Date 
            ? fv.fecha_vence.toISOString().split("T")[0] 
            : fv.fecha_vence,
          cantidad: parseFloat(fv.cantidad)
        }));

        this.productoEditarLotes.fechas_vencimiento = lotesProcesados;

        let sumaCant = lotesProcesados.reduce(
          (acc, curr) => acc + parseFloat(curr.cantidad || 0),
          0
        );
        if (sumaCant > 0) {
          this.productoEditarLotes.cantidad = sumaCant;
        }
      }
      this.displayFechaVence = false;
    },
    quitarProductoDetalle(datos) {
      this.$confirm.require({
        header: "Confirmación",
        message: "¿ESTÁS SEGURO DE QUITAR EL PRODUCTO DEL DETALLE?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si, Quitar",
        rejectLabel: "No, Cancelar",
        acceptClass: "p-button-primary p-button-lg",
        rejectClass: "p-button-danger p-button-lg",
        acceptIcon: "pi pi-save",
        rejectIcon: "pi pi-times",
        discard: () => {
          this.guardando = false;
        },
        accept: () => {
          this.traspasos.splice(datos.index, 1);
          this.$toast.add({
            severity: "success",
            summary: "Éxito",
            detail: "Producto quitado del detalle",
            life: 3000,
          });
        },
        reject: () => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "No se quito el producto del detalle",
            life: 3000,
          });
        },
      });
    },
  },
  watch: {
    sucursalSelected() {
      //recorro las sucursales para obtener el id de la sucursal destino
      this.sucursales.forEach((sucursal) => {
        if (sucursal.id != this.sucursalSelected) {
          this.sucursalDestinoSelected = sucursal.id;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
.p-fondo {
  background-color: #7bffae;
  border-radius: 5px;
  border: 1px solid #002236;
  padding: 5px;
}
.outofstock {
  font-weight: 700;
  color: #000000;
  background-color: #ff5252;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.lowstock {
  font-weight: 700;
  color: #000000;
  background-color: #fbc02d;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.instock {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 0 0.5em;
  border-radius: 0.5em;
}
</style>
